"use client"

import { Images } from "@/constants/images"
import { t } from "@/languages/i18n"
import { TranslationOutlined } from "@ant-design/icons"
import { Select, Typography } from "antd"
import Image from "next/image"

const { Text } = Typography

interface CategoryLanguagePublishProps {
  language: string
  setLanguages: (language: string) => void
  disabled?: boolean
}

export const CategoryLanguagePublish = ({
  language,
  setLanguages,
  disabled = false
}: CategoryLanguagePublishProps) => {

  const handleChange = (value: { value: string; label: React.ReactNode }) => {
    setLanguages(value.value)
  }

  const languageOptions = [
    {
      value: "vi",
      label: (
        <div className="flex items-center gap-2">
          <Image src={Images.logoVi} alt="Vietnamese" className="w-5 h-5" />
          {t("VI")}
        </div>
      ),
    },
    {
      value: "en",
      label: (
        <div className="flex items-center gap-2">
          <Image src={Images.logoEn} alt="English" className="w-5 h-5" />
          {t("EN")}
        </div>
      ),
    },
    {
      value: "cs",
      label: (
        <div className="flex items-center gap-2">
          <Image src={Images.logoCs} alt="Czech" className="w-5 h-5" />
          {t("CS")}
        </div>
      ),
    },
  ]

  const selectedOption = languageOptions.find(option => option.value === language)

  return (
    <div>
      <Text className="text-sm space-x-3">
        <TranslationOutlined /> {t("Ngôn ngữ")}:
        <Select
          labelInValue
          className="w-fit"
          onChange={handleChange}
          options={languageOptions}
          value={selectedOption ? { value: selectedOption.value, label: selectedOption.label } : undefined}
          disabled={disabled}
          loading={!language}
        />
      </Text>
    </div>
  )
}